<section class="accessibility-block">
	<img src="../assets/styles/resources/orange.png" alt="orange" />
</section>
<app-header *ngIf="showHeader" class="header"></app-header>
<router-outlet></router-outlet>
<app-keyboard *ngIf="(keyboardService.keyboard$ | async).isShow" class="keyboard"> </app-keyboard>
<app-nav *ngIf="showNav || (errorService.hasError$ | async)" class="nav"></app-nav>
<app-footer class="footer" *ngIf="showFooter" [showStartFooter]="!showHeader"></app-footer>
